import * as Sentry from "@sentry/react";
import { deliveryDiagnostic, type DeliveryDiagnosticInput } from "@shared/ads-manager-delivery-diagnostic";

export function newDeliveryReference(): string {
  return crypto.randomUUID();
}
/** Existing browser monitoring path; diagnostics never throw or resend a change. */
export function reportDeliveryDiagnostic(input: DeliveryDiagnosticInput): void {
  let event: ReturnType<typeof deliveryDiagnostic>;
  try {
    event = deliveryDiagnostic(input);
  } catch { return; }
  try { console.warn(JSON.stringify(event)); } catch { /* Console may be unavailable. */ }
  try {
    Sentry.captureMessage("ads_manager_delivery_interaction", {
      level: "warning", tags: { feature: "ads-manager", reason: event.reasonCode, reference: event.correlationId ?? "unavailable" },
      extra: event,
    });
  } catch { /* Logging must not change the outcome. */ }
}
